import React, { useState } from 'react';
import { Fade } from 'react-bootstrap';
import ButtonDelete from 'utils/buttons/ButtonDelete';
import PropTypes from 'prop-types';
import SoftBadge from 'components/common/SoftBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CropperImage from 'components/common/cropper/CropperImage';
import ButtonEdit from 'utils/buttons/ButtonEdit';
import { useDispatch } from 'react-redux';
import { editImage } from 'redux/propsSlice';
import { editImageProject } from 'redux/projectsSlice';
import { getImageUrl } from '../../utils/imageUrl';

const urlObj = {
  project: 'projects',
  property: 'properties'
};

const editImgObj = {
  project: editImageProject,
  property: editImage
};

export const ImageCard = ({
  index,
  image,
  handleDelete,
  accessor,
  propId,
  setData,
  parent
}) => {
  const dispatch = useDispatch();

  const [hover, setHover] = useState(false);
  const [openCropper, setOpenCropper] = useState(false);

  const handleCrop = async croppedImage => {
    if (croppedImage.file) {
      const formData = new FormData();

      formData.append('image', croppedImage.file);
      formData.append('accessor', accessor);
      formData.append('filename', image.filename);

      const response = await dispatch(editImgObj[parent](propId, formData));

      if (response.status < 400) {
        setData(prev => ({
          ...prev,
          ...response.data
        }));

        setOpenCropper(false);
      }
    }
  };

  return (
    <div
      className="position-relative"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <img
        src={getImageUrl(
          image,
          urlObj[parent], // "properties" o "projects"
          propId, // o propertyId / projectId según corresponda
          accessor === 'houseMaps' ? 'houseMaps' : ''
        )}
        className="rounded w-100"
        style={{
          aspectRatio: '1/1',
          objectFit: 'cover'
        }}
        alt={image?.title}
      />

      {index === 0 && accessor === 'images' && (
        <div
          className="position-absolute"
          style={{
            bottom: 5,
            left: 5
          }}
        >
          <SoftBadge bg="light">Foto Principal</SoftBadge>
        </div>
      )}

      <Fade in={hover} timeout={500}>
        <div>
          <div
            className="bg-dark text-white d-flex justify-content-center align-items-center fs-1 w-100 h-100 position-absolute"
            style={{
              top: 0,
              left: 0,
              aspectRatio: '1/1',
              opacity: 0.3
            }}
          >
            <FontAwesomeIcon icon="up-down-left-right" size="5x" />
          </div>
        </div>
      </Fade>

      <Fade in={hover} timeout={500}>
        <div
          className="position-absolute prevent-drag d-flex flex-column gap-2"
          style={{
            top: 5,
            right: 5
          }}
        >
          <ButtonEdit
            tooltipPosition="left"
            funcion={() => setOpenCropper(true)}
            style={{
              borderRadius: '50%',
              aspectRatio: '1/1',
              zIndex: 10000
            }}
          />

          <ButtonDelete
            tooltipPosition="left"
            style={{
              borderRadius: '50%',
              aspectRatio: '1/1',
              zIndex: 10000
            }}
            funcion={handleDelete}
            data={{
              filename: image.url ? image.url : image.filename
            }}
          />
        </div>
      </Fade>

      {openCropper && (
        <CropperImage
          onCropEnd={handleCrop}
          open={openCropper}
          setOpen={setOpenCropper}
          image={getImageUrl(
            image,
            urlObj[parent], // "properties" o "projects"
            propId, // o propertyId / projectId según corresponda
            accessor === 'houseMaps' ? 'houseMaps' : ''
          )}
        />
      )}
    </div>
  );
};
ImageCard.propTypes = {
  index: PropTypes.number.isRequired,
  image: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  accessor: PropTypes.string.isRequired,
  propId: PropTypes.string.isRequired,
  setData: PropTypes.func.isRequired,
  parent: PropTypes.oneOf(['property', 'project']).isRequired
};
